module.exports = __webpack_public_path__ + "static/img/zuhefaPro.9202cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/zuhefaPro.png
// module id = D/WS
// module chunks = 1